const pad = (value) => String(value).padStart(2, '0')

// Parse receipt dates returned by LLM in various formats (DD/MM/YYYY, DD-MM-YYYY,
// YYYY-MM-DD, ISO 8601, etc.) into a Date object. Falls back to standard Date
// parsing for ISO strings, then to the raw value if all parsing fails.
function safeDate(value) {
  if (!value && value !== 0) return null

  // Try standard ISO parsing first (covers ISO 8601, server timestamps).
  const iso = new Date(value)
  if (!Number.isNaN(iso.getTime())) return iso

  // LLM often returns DD/MM/YYYY or DD-MM-YYYY with optional time.
  const trimmed = String(value).trim()
  const euMatch = trimmed.match(
    /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  )
  if (euMatch) {
    const [, dd, mm, yyyy, hh, min, ss] = euMatch
    return new Date(
      Number(yyyy),
      Number(mm) - 1,
      Number(dd),
      hh ? Number(hh) : 0,
      min ? Number(min) : 0,
      ss ? Number(ss) : 0,
    )
  }

  return null
}

function formatEuDateTime(date, withTime = true) {
  const dd = pad(date.getDate())
  const mm = pad(date.getMonth() + 1)
  const yyyy = date.getFullYear()
  if (!withTime) return `${dd}-${mm}-${yyyy}`
  const hh = pad(date.getHours())
  const min = pad(date.getMinutes())
  const ss = pad(date.getSeconds())
  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`
}

export function formatDate(value) {
  const date = safeDate(value)
  if (!date) return String(value || '-')
  return formatEuDateTime(date, false)
}

export function formatDateTime(value) {
  const date = safeDate(value)
  if (!date) return String(value || '-')
  return formatEuDateTime(date, true)
}
